import { Button, Card, Form, Input, Select } from "antd";
import { useNavigate } from "react-router-dom";

import { formItemLayout, inputLayout } from "../../../constants/ApplicationConstants/FormConstants";
import FormInputRules from "../../../util/FormInputRules";
import { General } from "../../../util/General";
import { RouteConstants } from "../../../constants/ApplicationConstants/RouteConstants";

const { Option } = Select;

const StoreOrRetrievalParking = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  const handleSubmit = () => {
    navigate(`${RouteConstants.BOOKING_RETRIEVAL_REQUEST_PAGE}`);
  };
  return (
    <Card className="gx-card card--height" title="Manual Store or Retrieval">
      <Form {...formItemLayout}>
        <Form.Item {...inputLayout} name="customer_id" label="Customer Name" rules={[FormInputRules.requiredFieldSelectRule("customer")]}>
          <Select showSearch allowClear getPopupContainer={(trigger) => trigger.parentElement} filterOption={General.searchFilterOnSelect} placeholder="Select Customer">
            <Option>Customer 1</Option>
          </Select>
        </Form.Item>
        <Form.Item {...inputLayout} name="key_fob" label="Enter key FOB" normalize={General.inputWhiteSpaceRemove} rules={[FormInputRules.requiredFieldInputRule("key FOB")]}>
          <Input name="key_fob" />
        </Form.Item>
        <Form.Item className="form-button form-button-pr ">
          <Button className="gx-mb-0 button-gradiant" onClick={handleSubmit}>
            Submit
          </Button>
        </Form.Item>
        <Form.Item className="form-button form-button-pr ">
          <Button className="gx-mb-0 button-gradiant" onClick={handleBack}>
            Back
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
export default StoreOrRetrievalParking;
